(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nf-video"] && !Shopify.designMode) return;
  try {
    class NFVideoBlock {
    constructor(block) {
      this.block = block;
      this.video = block.querySelector('[data-nf-video]');
      this.playButton = block.querySelector('[data-nf-play-button]');
      this.overlay = block.querySelector('.nf-video-overlay');
      this.content = block.querySelector('.nf-video-content');
      
      this.init();
    }

    init() {
      if (this.playButton && this.video) {
        this.playButton.addEventListener('click', () => this.playVideo());
      }

      if (this.video) {
        this.video.addEventListener('play', () => this.onVideoPlay());
        this.video.addEventListener('pause', () => this.onVideoPause());
        this.video.addEventListener('ended', () => this.onVideoEnded());
      }
    }

    onVideoPlay() {
      console.log('Video started playing');
      this.block.classList.add('playing');
      
      // Update play button to show pause state
      if (this.playButton) {
        this.playButton.innerHTML = `
          <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
            <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
          </svg>
          Pause
        `;
        this.playButton.addEventListener('click', () => this.pauseVideo());
      }
    }

    onVideoPause() {
      console.log('Video paused');
      this.block.classList.remove('playing');
      
      // Update play button to show play state
      if (this.playButton) {
        this.playButton.innerHTML = `
          <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clip-rule="evenodd"></path>
          </svg>
          Play Video
        `;
        this.playButton.addEventListener('click', () => this.playVideo());
      }
    }

    onVideoEnded() {
      console.log('Video ended');
      this.block.classList.remove('playing');
      
      // Reset play button to show play state
      if (this.playButton) {
        this.playButton.innerHTML = `
          <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clip-rule="evenodd"></path>
          </svg>
          Play Video
        `;
        this.playButton.addEventListener('click', () => this.playVideo());
      }
    }

    pauseVideo() {
      // Find the deferred-media poster button and trigger it
      const deferredMediaButton = this.block.querySelector('.deferred-media__poster-button');
      if (deferredMediaButton) {
        console.log('Found deferred-media button, triggering click to pause');
        deferredMediaButton.click();
        return;
      }
      
      // Fallback to direct video control if no deferred-media button
      if (this.video.tagName === 'VIDEO') {
        this.video.pause();
      }
    }

    playVideo() {
      // Find the deferred-media poster button and trigger it
      const deferredMediaButton = this.block.querySelector('.deferred-media__poster-button');
      if (deferredMediaButton) {
        console.log('Found deferred-media button, triggering click');
        deferredMediaButton.click();
        this.block.classList.add('playing');
        return;
      }
      
      // Fallback to direct video control if no deferred-media button
      console.log('No deferred-media button found, using direct video control');
      if (this.video.tagName === 'VIDEO') {
        this.video.play();
        this.block.classList.add('playing');
      } else if (this.video.tagName === 'IFRAME') {
        // For YouTube/Vimeo iframes, we need to trigger play via postMessage
        const videoId = this.getVideoId();
        if (videoId) {
          this.video.src = this.video.src + '&autoplay=1';
          this.block.classList.add('playing');
        }
      }
    }

    getVideoId() {
      const src = this.video.src;
      if (src.includes('youtube.com') || src.includes('youtu.be')) {
        const match = src.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/);
        return match ? match[1] : null;
      } else if (src.includes('vimeo.com')) {
        const match = src.match(/vimeo\.com\/(\d+)/);
        return match ? match[1] : null;
      }
      return null;
    }
  }

  // Initialize all NF video blocks
  document.addEventListener('DOMContentLoaded', () => {
    const blocks = document.querySelectorAll('.nf-video-block');
    blocks.forEach(block => new NFVideoBlock(block));
  });

  // Handle dynamic content loading
  document.addEventListener('shopify:section:load', (event) => {
    const blocks = event.target.querySelectorAll('.nf-video-block');
    blocks.forEach(block => new NFVideoBlock(block));
  });
  } catch(e) { console.error(e); }
})();

})();
